import ConversionBannerFinance from '../banners/ConversionBannerFinance';

export default function getBanner(flowName) {
    switch (flowName) {
        case 'finance':
            return ConversionBannerFinance;
        default:
            return null;
    }
}
